import React, { useState, useEffect } from 'react';
import { GlobalKPIs } from '../types';
import logo from '../onimus_branco.png';

interface Props { kpis: GlobalKPIs; }

function fmtHHMMSS(d: Date): string {
  return [d.getHours(), d.getMinutes(), d.getSeconds()]
    .map(n => String(n).padStart(2, '0')).join(':');
}

export default function Header({ kpis }: Props) {
  const [clock, setClock] = useState(() => fmtHHMMSS(new Date()));

  useEffect(() => {
    const id = setInterval(() => setClock(fmtHHMMSS(new Date())), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <img src={logo} alt="OnGears" style={{ height: 36, objectFit: 'contain' }} />
        </div>

        <div className="header-stats">
          <div className="header-stat">
            <span className="header-stat-val blue">{kpis.totalProduced.toLocaleString('pt-BR')}</span>
            <span className="header-stat-lbl">Peças Produzidas</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-val">{kpis.totalTarget.toLocaleString('pt-BR')}</span>
            <span className="header-stat-lbl">Meta do Turno</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-val green">{kpis.activeMachines}</span>
            <span className="header-stat-lbl">Ativas</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-val yellow">{kpis.idleMachines}</span>
            <span className="header-stat-lbl">Ociosas</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-val red">{kpis.offlineMachines + kpis.maintenanceMachines}</span>
            <span className="header-stat-lbl">Paradas</span>
          </div>
          <div className="header-stat">
            <span className="header-stat-val blue">{kpis.overallEfficiency}%</span>
            <span className="header-stat-lbl">Eficiência Geral</span>
          </div>
        </div>

        <div className="header-right">
          <div className="live-badge">
            <span className="live-dot" />
            Ao Vivo
          </div>
          <span className="clock">{clock}</span>
        </div>
      </div>
    </header>
  );
}
